import { C as e, D as o, a as t, b as n, R as E, d as r, h as i, m as D, n as R, l as T, o as l, e as p, i as N, j as S, k as _, f as c, s as A, t as C, v as I } from "./index-2dea620f.js";
export {
  e as CONTEXT_LINES_ENDPOINT,
  o as DEFAULT_ANCHOR,
  t as DEFAULT_EXPERIMENTS,
  n as DEFAULT_SIDECAR_URL,
  E as React,
  r as ReactDOM,
  i as closeSpotlight,
  D as console,
  R as hydrationError,
  T as init,
  l as off,
  p as on,
  N as onClose,
  S as onOpen,
  _ as onSevereEvent,
  c as openSpotlight,
  A as sentry,
  C as trigger,
  I as viteInspect
};
//# sourceMappingURL=sentry-spotlight.js.map
